/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class ContactIgnoreService {

  constructor(private http: HttpClient) { }

  getAll(): Observable<any> {
    return this.http
      .get(
        `/api/v1/contact_ignore`
      );
  }

  saveNew(model: any): Observable<any> {
    return this.http
      .post(
        `/api/v1/contact_ignore`,
        model
      );
  }
}


// WEBPACK FOOTER //
// ./client/app/services/contact-ignore.service.ts